import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const grid = css`
  margin-top: ${size[32]};
  display: flex;
  flex-direction: column;
  gap: ${size[16]};
  width: 100%;

  ${breakpoint.up('smMd')} {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 420px));
    grid-auto-rows: 1fr;
    gap: ${size[32]};
  }
`
